import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { saveToken } from "./authService";
import "../admin_module/styles/AdminLoginPage.css";

const AdminLoginPage = () => {
 const [username, setUsername] = useState("");
 const [password, setPassword] = useState("");
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState("");

 const navigate = useNavigate();

 const handleLogin = async (e) => {
 e.preventDefault();
 setError("");
 setLoading(true);

 try {
 const response = await axios.post(
 `${process.env.REACT_APP_BASE_URL}/admin/auth/login`,
 { username, password }
 );

 saveToken(response.data.token, response.data.refreshToken);

 navigate("/admin", { replace: true });
 } catch (err) {
 setError("Invalid admin credentials");
 } finally {
 setLoading(false);
 }
 };

 return (
 <div className="admin-login-container">
 <form className="admin-login-card" onSubmit={handleLogin}>
 <h2>Admin Login</h2>
 <p className="subtitle">SpeakBold Admin Panel</p>

 {error && <div className="error-msg">{error}</div>}

 <input
 type="text"
 placeholder="Username"
 value={username}
 onChange={(e) => setUsername(e.target.value)}
 required
 />

 <input
 type="password"
 placeholder="Password"
 value={password}
 onChange={(e) => setPassword(e.target.value)}
 required
 />

 <button type="submit" disabled={loading}>
 {loading ? "Logging in..." : "Login"}
 </button>
 </form>
 </div>
 );
};

export default AdminLoginPage;
